var _style, _g, _g2, _defs, _pattern, _path, _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _polyline, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _polyline2, _polygon, _rect7, _rect8, _polygon2, _line9, _line0, _rect9, _path2, _line1, _rect0, _path3, _path4, _path5, _path6, _polygon3, _path7, _polygon4, _polygon5, _polygon6, _path8, _polygon7, _rect1, _rect10, _rect11, _rect12, _polygon8, _path9, _polygon9, _path0, _polygon0, _circle2, _rect13, _rect14, _rect15, _polygon1, _ellipse, _rect16, _polygon10, _ellipse2, _rect17, _polygon11, _rect18, _rect19, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2021OpKertovakuvitus28818(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#BFBEBE;}\n\t.st3{clip-path:url(#SVGID_00000089532906120124498920000017746023865660584635_);}\n\t.st4{fill:url(#SVGID_00000174566674934219959680000007876726096198703497_);}\n\t.st5{fill:#FFFFFF;stroke:#6F6F6F;stroke-width:1.59;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:#FFFFFF;stroke:#6F6F6F;stroke-width:1.59;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#6F6F6F;stroke-width:1.59;stroke-linecap:round;stroke-linejoin:round;}\n")), /*#__PURE__*/React.createElement("pattern", {
    y: 288,
    width: 15,
    height: 10,
    patternUnits: "userSpaceOnUse",
    id: "SVGID_4_",
    viewBox: "5 -15 15 10",
    style: {
      overflow: "visible"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: -15,
    className: "st0",
    width: 15,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: -15,
    className: "st0",
    width: 15,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: -15,
    className: "st0",
    width: 15,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: -15,
    className: "st0",
    width: 15,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.5-10h-5L15-15l2.5-5h5l2.5,5L22.5-10z M20-17c-1.1,0-2,0.9-2,2s0.9,2,2,2c1.1,0,2-0.9,2-2S21.1-17,20-17z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 20,
    cy: -15,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5-10h-5L0-15l2.5-5h5l2.5,5L7.5-10z M5-17c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S6.1-17,5-17z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 5,
    cy: -15,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.5,0h-5L15-5l2.5-5h5L25-5L22.5,0z M20-7c-1.1,0-2,0.9-2,2s0.9,2,2,2c1.1,0,2-0.9,2-2S21.1-7,20-7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 20,
    cy: -5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15-5h-5l-2.5-5l2.5-5h5l2.5,5L15-5z M12.5-12c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S13.6-12,12.5-12z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.5,
    cy: -10,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,0h-5L0-5l2.5-5h5L10-5L7.5,0z M5-7C3.9-7,3-6.1,3-5s0.9,2,2,2s2-0.9,2-2S6.1-7,5-7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 5,
    cy: -5,
    r: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000034774516078216336070000006819816675046606495_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st1",
    width: 288,
    height: 288
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000096037716497209620200000017664292345640951991_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 142.3,
    cy: 144,
    r: 134.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081610428119334622800000017038492580065067930_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000081610428119334622800000017038492580065067930_)"
    }
  }, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_00000056406700876749490620000005825536273840371593_",
    xlinkHref: "#SVGID_4_",
    patternTransform: "matrix(0.79 0 0 -0.79 -1614.3198 -32451.1289)"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000056406700876749490620000005825536273840371593_)"
    },
    cx: 142.3,
    cy: 144,
    r: 134.6
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-28,167.2c161.2-19.7,354-45.2,360.6,16.1l-55.8,80l-39.3-5.2l-261-47.6L-28,167.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 97.4,
    cy: 51.2,
    r: 10.1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 106.5,
    y1: 60.5,
    x2: 112.9,
    y2: 66.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 82,
    y1: 36,
    x2: 88.4,
    y2: 42.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 88.4,
    y1: 60.5,
    x2: 82,
    y2: 66.9
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 112.9,
    y1: 36,
    x2: 106.5,
    y2: 42.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 84.7,
    y1: 51.4,
    x2: 75.6,
    y2: 51.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 119.3,
    y1: 51.4,
    x2: 110.2,
    y2: 51.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 97.4,
    y1: 38.7,
    x2: 97.4,
    y2: 29.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 97.4,
    y1: 73.3,
    x2: 97.4,
    y2: 64.2
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "235.8,243.9 235.8,125.3 180.1,125.3 180.1,258  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 177.1,
    className: "st7",
    width: 13.5,
    height: 13.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 136.1,
    className: "st7",
    width: 13.5,
    height: 13.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 156.4,
    className: "st7",
    width: 13.5,
    height: 13.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 211.4,
    y: 177.1,
    className: "st7",
    width: 13.5,
    height: 13.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 211.4,
    y: 136.1,
    className: "st7",
    width: 13.5,
    height: 13.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 211.4,
    y: 156.4,
    className: "st7",
    width: 13.5,
    height: 13.5
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "290.4,218.1 290.4,141 263.5,140.8 263.5,166.8 259.3,166.8 259.3,153.1 235.8,153.1  "
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "205.4,77 206.6,77 207.9,88 204.1,88  "
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 204.1,
    y: 91.6,
    className: "st5",
    width: 3.7,
    height: 33.7
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 172.6,
    y: 88.1,
    className: "st5",
    width: 86.8,
    height: 3.7
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "249.8,91.8 248.1,109.9 247,91.8  "
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 248.4,
    y1: 88.1,
    x2: 206.6,
    y2: 77
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 205.4,
    y1: 77,
    x2: 172.6,
    y2: 88.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 172.6,
    y: 91.8,
    className: "st5",
    width: 12.2,
    height: 6.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M248.1,107.4v5.8c-0.1,1,0.1,2,0.4,3c0.3,0.5,0.9,0.8,1.5,0.8c1.4,0,1.3-1.9,1.3-1.9"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 250,
    y1: 117,
    x2: 250,
    y2: 126.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 126.5,
    className: "st5",
    width: 14.3,
    height: 3.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M162,35.1c3.1,0,5.7,2.5,5.7,5.7c0,3.1-2.5,5.7-5.7,5.7h-19.7c-3.1,0-5.7-2.5-5.7-5.7 c0-3.1,2.5-5.7,5.7-5.7h1.9c0-2.1,1-4,2.5-5.3c1.6-1.3,3.5-2,5.5-2.1c2-0.1,3.9,0.6,5.3,1.9c1.4,1.5,2.2,3.4,2.2,5.5H162z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M130.8,57.1c5.1,0,9.2,4.1,9.2,9.2c0,5.1-4.1,9.2-9.2,9.2H98.5c-5.1,0-9.2-4.1-9.2-9.2s4.1-9.2,9.2-9.2 h3.1c0.1-3.4,1.6-6.5,4.1-8.7c2.5-2.1,5.7-3.3,9-3.3c3.6,0,6.7,1,8.7,3.1c2.3,2.4,3.6,5.7,3.6,9L130.8,57.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-15.5,178.8c165.2-2.5,272,18.3,272,92.6l-43,41.2h-116l-82.2-41.3l-60.9-61.1L-15.5,178.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.3,200.2c18.6,27.1,15.2,34.6,11,38.8s-17.4,4.1-21.5,0.2C201.6,235,198.3,227.5,216.3,200.2z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "216,227 216.5,227 216.7,227 217.1,227 220.1,258.1 216.9,258.1 216.7,258.1 213.4,258.1  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M223.6,195.2c2.3-3.2,4.8-5.2,10.4-5.2l0,0c5.6,0,8.1,1.9,10.4,5.2c3.6,5,5.2,15.7,1.9,21.9 s-12,5.5-12,5.5H234c0,0-8.6,0.8-12.1-5.3S220.1,200.2,223.6,195.2z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "235.6,207.4 237.5,246.2 231.2,246.2 231.9,218.9 226.5,213.7 228.3,212 231.9,215.3 232.3,207.4  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.3,144.3 35.3,183.3 15.3,183.3 15.3,149.1  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "53.7,121.8 57.2,123.8 57.2,116.8 53.7,116.8  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M55.4,114.7c-1.5-0.1-1.3-2-1.3-2s-2.2-1.7-0.8-3.9c0.7-1.3,2.3-1.7,3.6-1c0,0,0,0,0,0 c0.2-0.4,0.6-0.8,1-1.1c-0.6-1.1-0.1-2.4,0.9-3c0.9-0.5,2.1-0.2,2.7,0.6c-0.1-1,0.4-1.9,1.3-2.3c1-0.5,2.3-0.1,2.8,0.9v0.1 c0.4,1,0,2.2-1,2.6c-0.1,0.1-0.2,0.1-0.3,0.1c0.3,1-0.3,2.1-1.3,2.4c0,0,0,0,0,0c-0.3,0.1-0.5,0.1-0.8,0.1c0.3,1,0,2.1-0.8,2.8 c-1.7,1.5-3,0.6-3,0.6c-0.3,0.6-0.9,1-1.5,1.3C57,112.9,57.1,114.8,55.4,114.7z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34.2,183.3 74.8,183.3 74.8,135.5 48.3,121 34.2,120.9  "
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 157.8,
    className: "st5",
    width: 11.8,
    height: 19.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3,
    y: 157.8,
    className: "st5",
    width: 11.8,
    height: 19.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 57.3,
    y: 157.8,
    className: "st5",
    width: 11.8,
    height: 19.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 59.6,
    y: 137.3,
    className: "st5",
    width: 9.5,
    height: 7.1
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "31.9,119.1 48.2,119.1 48.2,119.1 81,136.5 81,139.8 47.8,122 31.9,121.9  "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.5,169c-2.1-2.9-4.3-4.6-9.3-4.7l0,0c-5,0-7.2,1.7-9.3,4.5c-3.3,4.4-4.7,13.9-1.8,19.3 s10.7,4.8,10.7,4.8h0.3c0,0,7.8,0.7,10.8-4.7S78.7,173.4,75.5,169z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "64.8,179.7 63,219.4 68.7,219.4 68.1,189.9 72.9,185.3 71.3,183.7 68.1,186.8 67.8,179.7  "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M68.3,220.1h-27c0,0-6.1-0.8-5.3-6.9c0.7-5.9,7-4.5,7-4.5s-2.8-6.7,4.3-9.2c6.7-2.4,9.1,4.6,9.1,4.6 s4.1-3.6,7.8-0.6c1.9,1.4,2.7,3.9,1.9,6.1c0,0,4.6-2.6,7.3,1.8c1.3,2,1,5.2-0.5,6.7C71.7,219.3,70,220.1,68.3,220.1z"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "134.8,110.8 130.6,141.2 138.2,141.5  "
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 134.4,
    cy: 158.4,
    r: 23.3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 207.3,
    className: "st5",
    width: 88.5,
    height: 35.8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 111.2,
    y: 157.6,
    className: "st5",
    width: 46.4,
    height: 49.8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 243.1,
    className: "st7",
    width: 88.5,
    height: 37.8
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "95.6,176.3 93.6,191.9 97.3,192  "
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 95.5,
    cy: 200.8,
    rx: 11.1,
    ry: 12
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 84.4,
    y: 201.2,
    className: "st5",
    width: 22.3,
    height: 79.8
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "173.5,176.3 171.5,191.9 175.1,192  "
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 173.3,
    cy: 200.8,
    rx: 11.2,
    ry: 12
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 162.2,
    y: 201.2,
    className: "st5",
    width: 22.3,
    height: 79.8
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "153.7,243.1 115.1,243.1 134.4,219.4  "
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 121.8,
    y: 243.1,
    className: "st7",
    width: 5.6,
    height: 37.8
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 140.6,
    y: 243.1,
    className: "st7",
    width: 5.6,
    height: 37.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 134.4,
    cy: 170.6,
    r: 5.6
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2021OpKertovakuvitus28818);
export default __webpack_public_path__ + "static/media/2021_OP_kertovakuvitus_288-18.be00036d1ce50b4d11bc047df241bfa9.svg";
export { ForwardRef as ReactComponent };